import Fluxible from 'fluxible';
import fetchrPlugin from 'fluxible-plugin-fetchr';
import batchedUpdatePlugin from 'fluxible-addons-react/batchedUpdatePlugin';
import Application from './Application';
import Actions from './constants/Actions';
// stores
import AuditDashboardStore from './stores/AuditDashboardStore';
import AuditStore from './stores/AuditStore';
import AuthenticationStore from './stores/AuthenticationStore';
import BankStore from './stores/BankStore';
import BillingStore from './stores/BillingStore';
import ComplianceDashboardStore from './stores/ComplianceDashboardStore';
import ComplianceStore from './stores/ComplianceStore';
import ConfigStore from './stores/ConfigStore';
import EmployeeStore from './stores/EmployeeStore';
import FavoriteStore from './stores/FavoriteStore';
import GuideStore from './stores/GuideStore';
import HistogramStore from './stores/HistogramStore';
import HtmlHeadStore from './stores/HtmlHeadStore';
import IntlStore from './stores/IntlStore';
import LearnMoreStore from './stores/LearnMoreStore';
import ManageAccountStore from './stores/ManageAccountStore';
import OnlinePerformanceStore from './stores/OnlinePerformanceStore';
import PortalUserStore from './stores/PortalUserStore';
import ProductActionStore from './stores/ProductActionStore';
import ProductMixStore from './stores/ProductMixStore';
import PublishStore from './stores/PublishStore';
import ReactRouterPlugin from './utils/route/ReactRouterPlugin';
import ResetPasswordStore from './stores/ResetPasswordStore';
import RouteStore from './stores/RouteStore';
import SalesLeaderboardStore from './stores/SalesLeaderboardStore';
import SignUpStore from './stores/SignUpStore';
import TeamPerformanceStore from './stores/TeamPerformanceStore';
import TrafficSummaryStore from './stores/TrafficSummaryStore';
import TransientStore from './stores/TransientStore';
import UserManagementStore from './stores/UserManagementStore';
import TopSourcesStore from './stores/TopSourcesStore';

async function componentActionErrorHandler(context, payload) {
  const { err } = payload;
  context.dispatch(Actions.APPLICATION__ERROR, { err, payload });
}

// Create the fluxible app using Application as root component
const app = new Fluxible({
  component: Application,
  componentActionErrorHandler
});

// Make fetchr services respond to /api endpoint
app.plug(fetchrPlugin({
  xhrPath: '/api',
  xhrTimeout: 100000
}));
app.plug(new ReactRouterPlugin());
app.plug(batchedUpdatePlugin());

// Register app-specific stores
app.registerStore(AuditDashboardStore);
app.registerStore(AuditStore);
app.registerStore(RouteStore);
app.registerStore(HtmlHeadStore);
app.registerStore(IntlStore);
app.registerStore(SalesLeaderboardStore);
app.registerStore(AuthenticationStore);
app.registerStore(BankStore);
app.registerStore(BillingStore);
app.registerStore(ComplianceDashboardStore);
app.registerStore(ComplianceStore);
app.registerStore(ConfigStore);
app.registerStore(EmployeeStore);
app.registerStore(FavoriteStore);
app.registerStore(GuideStore);
app.registerStore(HtmlHeadStore);
app.registerStore(HistogramStore);
app.registerStore(IntlStore);
app.registerStore(LearnMoreStore);
app.registerStore(ManageAccountStore);
app.registerStore(OnlinePerformanceStore);
app.registerStore(PortalUserStore);
app.registerStore(ProductActionStore);
app.registerStore(ProductMixStore);
app.registerStore(PublishStore);
app.registerStore(ResetPasswordStore);
app.registerStore(RouteStore);
app.registerStore(SalesLeaderboardStore);
app.registerStore(SignUpStore);
app.registerStore(TeamPerformanceStore);
app.registerStore(TopSourcesStore);
app.registerStore(TrafficSummaryStore);
app.registerStore(TransientStore);
app.registerStore(UserManagementStore);

export default app;



// WEBPACK FOOTER //
// ./src/fluxibleApp.js